<app-background backgroundImage="images/shared/backgrounds/background-1.avif">
  <h1 class="sr-only">SEM Nexus — Mobile App Development and App Marketing Agency</h1>
  <app-hero-section
    backgroundImage="images/landing/backgrounds/landing-1.webp" videoSrc="/video/home.mp4"
    align="left" [titleHtml]="heroTitleHtml"
    subcopy="As an award-winning agency, SEM Nexus partners with industry leaders to build and market high-performance digital platforms. We specialize in scaling complex systems and leveraging AI to create powerful mobile and web experiences that deliver measurable business results.">
    <app-button hero-cta buttonText="get in touch now!" (clicked)="scheduleCall()"></app-button>
  </app-hero-section>
  <!-- <app-brands></app-brands> -->
  @for (section of introSections; track $index) {
    <app-content-section [section]="section"></app-content-section>
  }
  <app-why-semnexus (goToSection)="goToSection($event)"></app-why-semnexus>
</app-background>
<app-background backgroundImage="images/shared/backgrounds/background-2.avif">
  <section #services class="-mt-[180px]">
    <app-services></app-services>
  </section>
  <hr class="section-divider" />
  <app-dev-services [section]="devSection" link="/app-development-company"></app-dev-services>
  <hr class="section-divider" />
  <app-tag-services [section]="mktSection" link="/mobile-app-marketing-services"></app-tag-services>
  <hr class="section-divider" />
  <app-lead-section [section]="aeoSection" headingAlign="right" link="/aeo-marketing-services"></app-lead-section>
  <hr class="section-divider" />
  <app-tag-services [section]="whyBusinessesSection" layout="center" marker="check"></app-tag-services>
  <hr class="section-divider" />
  <section #caseStudies>
    <app-case-studies></app-case-studies>
  </section>
</app-background>
<app-background backgroundImage="images/shared/backgrounds/background-3.avif">
  <app-team></app-team>
  <app-post-carousel-container></app-post-carousel-container>
  @for (section of bottomSections; track $index) {
    <app-content-section [section]="section"></app-content-section>
  }
  <app-connect></app-connect>
</app-background>
